import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IServiceInstructionResponse } from 'src/app/models/IServiceInstructions';
import { HttphelperService } from '../helpers/httphelper.service';
@Injectable()
export class ServiceInstructionService {
  baseUrl:string;
  constructor(private httpHelper:HttphelperService) {
  }
  getServiceInstructionsData(url:string):Observable<IServiceInstructionResponse>
  {
    return this.httpHelper.getRequest(url);
  }
}
